/**
 * Created by yaer on 2018/7/6;
 * @Email 740905172@qq.com
 **/
import Cookies from 'js-cookie';

const uuidKey = 'uuid'

export function setUUid() {
  // @ts-ignore
  let id;
  // 获取当前是否存在
  var existUUid = getUUid();
  if (existUUid == null || existUUid == "" || existUUid == undefined || existUUid == "undefined") {
    // 不存在则设置
    let id = uuid();
    Cookies.set(uuidKey, id)
  }
}

export function getUUid() {
  return Cookies.get(uuidKey)
}

//第一种
export function uuid() {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  // @ts-ignore
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return uuid;
}

/**
 * 获取地址栏参数
 * @returns {*}
 */
export function GetQueryString(key) {
   // 获取参数
   let url = window.location.search;
   // 正则筛选地址栏
   let reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
   // 匹配目标参数
   let result = url.substr(1).match(reg);
   //返回参数值
   return result ? decodeURIComponent(result[2]) : null;
}

/**
 * 获取系统
 * @returns {*}
 */
export function getSys() {
  let sys;
  let u = navigator.userAgent;
  let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isiOS) {
    // sys = "ios";
    sys = "IOS"
  } else {
    // sys = "android";
    sys = "ANDROID"
  }
  return sys;
}


/**
 * 嗑瓜子安卓、ios封装交互
 * @returns {*}
 */
// export function nativeKGZ(method,name,...args){
//   let sys;
//   let u = navigator.userAgent;
//   let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
//   if (isiOS) {
//     sys = window.webkit && window.webkit.messageHandlers[method].postMessage(args);
//   } else {
//     sys = window[name] && window[name][method](...args)
//   }
//   return sys
// }
/**
 * 嗑瓜子安卓、ios封装交互
 * @returns {*}
 */
export const nativeKGZ = (() => {
  let flag = getSys();
  return (method, name="yiqiwan", ...args) => {
    let sys;
    if (flag === "IOS") {
      sys = window.webkit && window.webkit.messageHandlers[method].postMessage(args);
    } else {
      sys = window[name] && window[name][method] && window[name][method](...args)
    }
    return sys;
  };
})()

/**
 * 是否有嗑瓜子环境
 * @returns {*}
 */
export function isKGZ(name="yiqiwan"){
  if(window.webkit || window[name]){
    return true
  }else{
    return false
  }
}

/**
 * 获取系统型号
 * @returns {{}}
 */
export function isBrowser() {
  let u = navigator.userAgent;
  window.browser = {};
  window.browser.iPhone = u.indexOf('iPhone') > -1; //iPhone or QQHD
  window.browser.android = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android or uc
  window.browser.ios = u.match(/Mac OS/); //ios
  window.browser.wx = u.match(/MicroMessenger/);
  return window.browser;
}


/**
 * 获取url的params
 * @param url url地址
 * @returns {Object}
 *
 */
export function GetRequest(url) {
  let theRequest = {};
  let index = url.indexOf("?");
  if (index !== -1) {
    let str = url.substr(index + 1);
    let strs = str.split("&");
    for (let i = 0; i < strs.length; i++) {
      const [key, val] = strs[i].split("=");
      theRequest[key] = val;
    }
  }
  return theRequest;
}

/**
 * fixed定位解决遮盖元素问题
 * @param cloneDom fixed定位的dom节点
 * @param company css单位 px rem
 * @param bool 不穿复制的dom100%高度，传true则复制的dom高度-1
 * @returns {*}
 */
export function fixedClone(cloneDom, company = 'rem', bool) {
  // 获取需要克隆节点的宽高
  // console.log(cloneDom.offsetHeight)
  let height = cloneDom.offsetHeight;
  let width = cloneDom.offsetWidth;
  // 生成dom并且获取html的fontSize
  let dom = document.createElement("div");
  let htmlFontSize = Number(window.document.documentElement.style.fontSize.split('px')[0]);

  //dom赋值
  if (bool) {
    if (company === 'rem') {
      dom.style.height = (height - 1) / htmlFontSize + 'rem';
      dom.style.width = width / htmlFontSize + 'rem';
    } else {
      dom.style.height = (height - 1) + 'px';
      dom.style.width = width + 'px';
    }
  } else {
    if (company === 'rem') {
      dom.style.height = height / htmlFontSize + 'rem';
      dom.style.width = width / htmlFontSize + 'rem';
    } else {
      dom.style.height = height + 'px';
      dom.style.width = width + 'px';
    }
  }
  // 插入dom 如果cloneDom的最后一个节点是cloneDom 那么就直接在最后插入dom 否则就在clone下一个节点前插入dom
  let parent = cloneDom.parentNode;
  if (parent.lastChild === cloneDom) {
    parent.appendChild(dom);
  } else {
    parent.insertBefore(dom, cloneDom.nextSibling)
  }
}

/**
 * 时间转换
 * @param date  毫秒值的时间
 * @param format  转换格式
 * @returns {string}
 */
export function setDate(date, format) {
  let time = new Date(date);
  let val = '';
  switch (format) {
    case 'yy-mm':
      val = `${time.getFullYear()}年${time.getMonth() + 1}月`;
      break;
    case 'yy-mm-dd':
      val = `${time.getFullYear()}年${time.getMonth() + 1}月${zero(time.getDate())}日`;
      break;
    case 'yy.mm.dd':
      val = `${time.getFullYear()}.${time.getMonth() + 1}.${zero(time.getDate())}`;
      break;
    case 'yymmdd':
      val = `${time.getFullYear()}${zero(time.getMonth() + 1)}${zero(time.getDate())}`;
      break;
    case 'yy-mm-dd-hh-ii':
      val = `${time.getFullYear()}-${time.getMonth() + 1}-${zero(time.getDate())}  ${zero(time.getHours())}:${zero(time.getMinutes())}`;
      break;
    case 'hh-ii':
      val = `${zero(time.getHours())}:${zero(time.getMinutes())}`;
      break;
    case 'hh-ii-ss':
      val = `${zero(time.getHours())}:${zero(time.getMinutes())}:${zero(time.getSeconds())}`;
      break;
  }
  return val
}

/**
 * 时间倒计时
 * @param mss 毫秒时间
 * @returns {string}
 */
export function formatDuring(mss) {
  let hours = zero(parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
  let minutes = zero(parseInt((mss % (1000 * 60 * 60)) / (1000 * 60)));
  let seconds = ((zero((mss % (1000 * 60)) / 1000)) + '').split('.')[0];
  return `${hours}:${minutes}:${seconds}`
}

/**
 * 补0
 * @param num Number数字
 * @returns {*}
 */
function zero(num) {
  if (num < 10) {
    return '0' + num
  } else {
    return num
  }
}

/**
 *  唤起APP
 * @param jumpLink  唤起APP的链接
 * @param download  唤起不成功的下载链接
 * @returns {*}
 */
export function AppJump(jumpLink, download) {

  //判断浏览器
  let u = navigator.userAgent;
  if (/MicroMessenger/gi.test(u)) {
    // 引导用户在浏览器中打开
    alert('请在浏览器中打开');
    return false;
  }
  let d = new Date();
  let t0 = d.getTime();
  openApp(jumpLink);
  let delay = setInterval(() => {
    let d = new Date();
    let t1 = d.getTime();
    if (t1 - t0 < 3000 && t1 - t0 > 2000) {
      // 这里跳转下载页
      window.location.href = download;
    }
    if (t1 - t0 >= 3000) {
      clearInterval(delay);
    }
  }, 1000);

  function openApp(src) {
    // 通过iframe的方式试图打开APP，如果能正常打开，会直接切换到APP，并自动阻止a标签的默认行为
    // 否则打开a标签的href链接

    if (getSys() === "ios") {
      window.location.href = src;
    } else {
      let ifr = document.createElement('iframe');
      ifr.src = src;
      ifr.style.display = 'none';
      document.body.appendChild(ifr);
      window.setTimeout(() => {
        document.body.removeChild(ifr);
      }, 2000);
    }
  }


}

/**
 * 版本判断
 * @returns {boolean}
 */
export function appVersion() {
  let header = window["nativeMethod"] &&
    window["nativeMethod"]["returnNativeMethod"] &&
    nativeMethod.getHeaders();
  let appVersion;
  if (header) {
    header = JSON.parse(header);
    console.log("****** appVersion:" + header.appVersion);
    appVersion = header.appVersion;
  }
  if (appVersion) {
    let Num = Number(appVersion.substring(0, 3));
    return Num < 2;
  }
  return false;
}


/**
 * 金额逢3加一个逗号
 * @returns {string}
 */
export function NumMoney(money) {
  let intPart = Number(money).toFixed(0); //获取整数部分
  let intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
  return intPartFormat
}

// 补全路径
export function getHref(url) {
  const {protocol,hostname} = window.location;
  let link = protocol + '//' + hostname + url;
  return link
}

// 金钱2位
export function toMoney(money = 0){
  return money.toFixed(2)
}
//判断是否滚动到底部
export function reachBottom() {
  var scrollTop = 0;
  var clientHeight = 0;
  var scrollHeight = 0;
  if (document.documentElement && document.documentElement.scrollTop) {
    scrollTop = document.documentElement.scrollTop;
  } else if (document.body) {
    scrollTop = document.body.scrollTop;
  }
  if (document.body.clientHeight && document.documentElement.clientHeight) {
    clientHeight = document.body.clientHeight < document.documentElement.clientHeight ? document.body.clientHeight : document.documentElement.clientHeight;
  } else {
    clientHeight = document.body.clientHeight > document.documentElement.clientHeight ? document.body.clientHeight : document.documentElement.clientHeight;
  }
  scrollHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
  if (scrollTop + clientHeight >= scrollHeight - 1) {
    return true;
  } else {
    return false;
  }
}

 // 是微信浏览器
 export function is_weixn() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return true;
  } else {
      return false;
  }
}
export function is_qq() {
  var sUserAgent = navigator.userAgent.toLowerCase();
  if (sUserAgent.match(/QQ/i) == 'qq') {
      return true
  } else {
      return false
  }
}

export function isMobile() {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return flag;
}



// WEBPACK FOOTER //
// ./src/utils/utils.js